export const KEY_TOKEN = 'token'
export const KEY_REFRESH_TOKEN = 'refresh_token'
export const KEY_ME = 'me'
export const KEY_IS_LOGIN_WITH_AZURE = 'is_login_with_azure'

// Auth
export const NO_TOKEN_BEARER_NEEDED_ENDPOINT = [
  '/auth/login',
  '/auth/login-azure',
  '/auth/login-otp',
  '/auth/verify-code',
  '/auth/resend-code'
]
export const AZURE_ERROR_NO_ACCOUNT_SIGNED_DETECTED = 'AADSTS50058' // No account available fo silent sign in
export const AZURE_ERROR_MULTIPLE_SIGNED_IDENTITIES = 'AADSTS16000' // Silent sign in error because multiple account signed in

// Schedule Of Shipment
export const KEY_THIRD_PARTY_CONFIG = 'third_party_config'
export const KEY_SOS_DETAIL_ID = 'detail_id'

// Sales Plan
export const KEY_SALES_PLAN_DETAIL_ID = 'sales_plan_detail_id'
export const KEY_SALES_PLAN_MONTHLY_PERIOD = 'monthly_period'
export const KEY_SALES_PLAN_ANNUAL_PERIOD = 'annual_period'

// Barge Line Up
export const KEY_BARGE_LINE_UP_DETAIL_ID = 'barge_detail_id'
export const KEY_BARGE_LINE_UP_CALCULATE_DEPARTURE_TO_SMD = [
  {
    key: 'bek',
    value: '41'
  },
  {
    key: 'bbe',
    value: '5'
  },
  {
    key: 'gam',
    value: '43'
  },
  {
    key: 'jmb',
    value: '10'
  },
  {
    key: 'kmia',
    value: '10'
  },
  {
    key: 'tcm',
    value: '41'
  },
  {
    key: 'sia',
    value: '5'
  },
  {
    key: 'default',
    value: '41'
  }
]
export const KEY_BARGE_LINE_UP_CALCULATE_LOADING_BERTHING_UNBERTHING = [
  {
    key: 'bek',
    value: '4'
  },
  {
    key: 'bbe',
    value: '15'
  },
  {
    key: 'gam',
    value: '4'
  },
  {
    key: 'jmb',
    value: '15'
  },
  {
    key: 'kmia',
    value: '15'
  },
  {
    key: 'tcm',
    value: '4'
  },
  {
    key: 'sia',
    value: '15'
  },
  {
    key: 'default',
    value: '4'
  }
]

export const KEY_BARGE_LINE_UP_CALCULATE_PASSING_BRIDGE_TO_POD = [
  {
    key: 'jbg',
    value: '96'
  },
  {
    key: 'boct',
    value: '30'
  },
  {
    key: 'mbr',
    value: '24'
  },
  {
    key: 'default',
    value: '24'
  }
]

export const KEY_BARGE_LINE_UP_CALCULATE_PASSING_BRIDGE_TO_SMDR = [
  {
    key: 'jbg',
    value: '96'
  },
  {
    key: 'boct',
    value: '17'
  },
  {
    key: 'mbr',
    value: '10'
  },
  {
    key: 'default',
    value: '24'
  }
]

export const KEY_BARGE_LINE_UP_CALCULATE_UNLOADING_BERTHING_UNBERTHING = [
  {
    key: 'jbg',
    value: [
      {
        key: 'fc',
        value: [
          {
            key: 'single',
            value: '12'
          }
        ]
      },
      {
        key: 'labor',
        value: [
          {
            key: 'single',
            value: '15'
          }
        ]
      },
      {
        key: 'default',
        value: '12'
      }
    ]
  },
  {
    key: 'boct',
    value: [
      {
        key: 'cbu',
        value: '6'
      },
      {
        key: 'default',
        value: '6'
      }
    ]
  },
  {
    key: 'mbr',
    value: [
      {
        key: 'iskandar',
        value: [
          {
            key: 'storage',
            value: '6'
          },
          {
            key: 'direct to vessel',
            value: '6'
          }
        ]
      },
      {
        key: 'labor',
        value: [
          {
            key: 'single',
            value: '15'
          }
        ]
      },
      {
        key: 'fc',
        value: [
          {
            key: 'single',
            value: '12'
          }
        ]
      },
      {
        key: 'apollo',
        value: [
          {
            key: 'single',
            value: '6'
          },
          {
            key: 'blending',
            value: '8'
          },
          {
            key: 'main blend',
            value: '18'
          }
        ]
      },
      {
        key: 'zeus',
        value: [
          {
            key: 'single',
            value: '6'
          },
          {
            key: 'blending',
            value: '8'
          },
          {
            key: 'main blend',
            value: '18'
          }
        ]
      },
      {
        key: 'mara',
        value: [
          {
            key: 'single',
            value: '6'
          },
          {
            key: 'blending',
            value: '8'
          },
          {
            key: 'main blend',
            value: '18'
          }
        ]
      },
      {
        key: 'default',
        value: '6'
      }
    ]
  },
  {
    key: 'default',
    value: '6'
  }
]
export const KEY_BARGE_LINE_UP_PRODUCT_DICTIONARY = [
  {
    original_name: "BEK.MCV.HS",
    aliases: [
      "BEK_MCVHS",
      "BEK_MCVHS",
      "bekmcvhs",
      "bek.mcv.hs",
      "bek_mcvhs",
      "bek_mcv_hs",
      "mcv_hs"
    ]
  },
  {
    original_name: "BEK.HCV.HS",
    aliases: [
      "BEK_HCVHS",
      "BEK_HCVHS",
      "bekhcvhs",
      "bek.hcv.hs",
      "bek_hcvhs",
      "bek_hcv_hs",
      "hcv_hs"
    ]
  },
  {
    original_name: "BEK.MCV.LS",
    aliases: [
      "BEK_MCVLS",
      "BEK_MCVLS",
      "bekmcvls",
      "bek.mcv.ls",
      "bek_mcvls",
      "bek_mcv_ls",
      "mcv_ls"
    ]
  },
  {
    original_name: "BEK.HCV.LS",
    aliases: [
      "BEK_HCVLS",
      "BEK_HCVLS",
      "bekhcvls",
      "bek.hcv.ls",
      "bek_hcvls",
      "bek_hcv_ls",
      "hcv_ls"
    ]
  },
  {
    original_name: "BEK.MCV.MS",
    aliases: [
      "BEK_MCVMS",
      "BEK_MCVMS",
      "bekmcvms",
      "bek.mcv.ms",
      "bek_mcvms",
      "bek_mcv_ms",
      "mcv_ms"
    ]
  },
  {
    original_name: "BEK.HCV.MS",
    aliases: [
      "BEK_HCVMS",
      "BEK_HCVMS",
      "bekhcvms",
      "bek.hcv.ms",
      "bek_hcvms",
      "bek_hcv_ms",
      "hcv_ms"
    ]
  },
  {
    original_name: "TCM.HCV.HS",
    aliases: [
      "TCM_HCVHS",
      "TCM_HCVHS",
      "tcmhcvhs",
      "tcm.hcv.hs",
      "tcm_hcvhs",
      "tcm_hcv_hs",
      "hcv_hs",
      "hcvhs"
    ]
  },
  {
    original_name: "TCM.HCV.LS",
    aliases: [
      "TCM_HCVLS",
      "TCM_HCVLS",
      "tcmhcvls",
      "tcm.hcv.ls",
      "tcm_hcvls",
      "tcm_hcv_ls",
      "hcv_ls",
      "hcvls"
    ]
  },
  {
    original_name: "TCM.HCV.MS",
    aliases: [
      "TCM_HCVMS",
      "TCM_HCVMS",
      "tcmhcvms",
      "tcm.hcv.ms",
      "tcm_hcvms",
      "tcm_hcv_ms",
      "hcv_ms",
      "hcvms"
    ]
  },
  {
    original_name: "TIS.HCV.HS",
    aliases: [
      "TIS_HCVHS",
      "TIS_HCVHS",
      "tishcvhs",
      "tis.hcv.hs",
      "tis_hcvhs",
      "tis_hcv_hs",
      "hcv_hs",
      "hcvhs"
    ]
  },
  {
    original_name: "TIS.HCV.LS",
    aliases: [
      "TIS_HCVLS",
      "TIS_HCVLS",
      "tishcvls",
      "tis.hcv.ls",
      "tis_hcvls",
      "tis_hcv_ls",
      "hcv_ls",
      "hcvls"
    ]
  },
  {
    original_name: "IMM.MCV.HS",
    aliases: [
      "IMM_MCVHS",
      "IMM_MCVHS",
      "bekmcvhs",
      "bek.mcv.hs",
      "bek_mcvhs",
      "bek_mcv_hs",
      "imm_wb_mcv_hs",
      "mcv_hs"
    ]
  },
  {
    original_name: "IMM.HCV.HS",
    aliases: [
      "IMM_HCVHS",
      "IMM_HCVHS",
      "immhcvhs",
      "imm.hcv.hs",
      "imm_hcvhs",
      "imm_hcv_hs",
      "hcv_hs"
    ]
  },
  {
    original_name: "IMM.MCV.LS",
    aliases: [
      "IMM_MCVLS",
      "IMM_MCVLS",
      "immmcvls",
      "imm.mcv.ls",
      "imm_mcvls",
      "imm_mcv_ls",
      "imm_eb_mcv_ls",
      "mcv_ls"
    ]
  },
  {
    original_name: "IMM.HCV.LS",
    aliases: [
      "IMM_HCVLS",
      "IMM_HCVLS",
      "immhcvls",
      "imm.hcv.ls",
      "imm_hcvls",
      "imm_hcv_ls",
      "imm_wb_hcv_ls",
      "hcv_ls"
    ]
  },
  {
    original_name: "IMM.MCV.MS",
    aliases: [
      "IMM_MCVMS",
      "IMM_MCVMS",
      "immmcvms",
      "imm.mcv.ms",
      "imm_mcvms",
      "imm_mcv_ms",
      "imm_eb_mcv_ms",
      "mcv_ms"
    ]
  },
  {
    original_name: "IMM.HCV.MS",
    aliases: [
      "IMM_HCVMS",
      "IMM_HCVMS",
      "immhcvms",
      "imm.hcv.ms",
      "imm_hcvms",
      "imm_hcv_ms",
      "hcv_ms"
    ]
  },
  {
    original_name: "EMB",
    aliases: [
      "EMB",
      "EMB",
      "emb"
    ]
  },
  {
    original_name: "JORONG",
    aliases: [
      "JORONG",
      "JORONG",
      "jorong"
    ]
  },
  {
    original_name: "GPK",
    aliases: [
      "GPK",
      "GPK",
      "gpk"
    ]
  },
  {
    original_name: "MBL",
    aliases: [
      "MBL",
      "MBL",
      "mbl"
    ]
  },
  {
    original_name: "EBH",
    aliases: [
      "EBH",
      "EBH",
      "ebh"
    ]
  }
]

// Vessel Line Up
export const KEY_VESSEL_LINE_UP_ID = 'vessel_line_up_id'
export const KEY_VESSEL_LINE_UP_END_USER = 'vessel_line_up_end_user'
export const KEY_IMM = {
  'imm_wb_hcv_ls': 'wb_hcv_ls',
  'imm_wb_mcv_hs': 'wb_mcv_hs',
  'imm_eb_mcv_ls': 'eb_mcv_ls',
  'imm_eb_mcv_ms': 'eb_mcv_ms',
  'imm_eb_mcv_hs': 'eb_mcv_hs'
}
export const KEY_TCM = {
  'tcm_hcv_ls': 'hcv_ls',
  'tcm_hcv_hs': 'hcv_hs',
  'tcm_hcv_ms': 'hcv_ms'
}
export const KEY_BEK = {
  'bek_mcv_ls': 'mcv_ls',
  'bek_hcv_ms': 'hcv_ms'
}
export const KEY_JBG = {
  'jbg': 'jbg'
}
export const KEY_KTD = {
  'emb': 'emb'
}

// Contract Management
export const KEY_CHARTER_TYPE = 'charter_type'
export const KEY_BARGE_ID_NAME = 'barge_id_name'
export const KEY_TUG_ID_NAME = 'tug_id_name'
export const KEY_TEMP_CONTRACT = 'temp_contract'
export const VALID_CATEGORY_CERTIFICATE = {
  'STATUS HUKUM': 'STATUS HUKUM',
  'SERTIFIKAT SOLAS/NVCS': 'SERTIFIKAT SOLAS/NVCS',
  'SERTIFIKAT DARI BADAN KLASIFIKASI': 'SERTIFIKAT BADAN KLASIFIKASI',
  'LSA/FFE': 'LSA/FFE',
  'PENCEGAHAN, PENCEMARAN, ASURANSI, PERLINDUNGAN LINGKUNGAN': 'SERTIFIKAT LINGKUNGAN',
  'LAIN-LAIN/OTHER': 'OTHER'
}

// Misc
export const PAGE_TITLE = 'SMS - BLMS | '
export const FILE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
export const INTERVAL_FETCH_TELEMATICS_IN_SECONDS = 60000
export const INTERVAL_FETCH_NOTIFICATION = 30000
export const FILTER_LAST_POSITION = 'show-last-position';
export const FILTER_TRIP = 'show-trip';


// ARCGIS Map
export const CENTER = [116.7863668, -0.5730562];
export const ZOOM_MIN = 5;
export const ZOOM = 10;
export const COLOR_TUGBOAT_DEFAULT = [84, 110, 122, 0.8]
export const KEY_POI_PORT = 'Port'
export const LAYER_ID_POI = 'poi'
export const LAYER_ID_TUGBOAT = 'tugboat'
export const LAYER_ID_VESSEL = 'vessel'
export const LAYER_ID_TRIP = 'trip'
export const LAYER_ID_TRIP_LINE = 'trip-line'
export const STATUS_LOADED_TRANSIT = 'Loaded Transit'
export const STATUS_WAITING_UNLOADING = 'Waiting Unloading'
export const TUG_TYPE = 'tugboat'
export const VESSEL_TYPE = 'vessel'
export const DOCKING_BARGE_TYPE = 'docking_barge'

// Barge Performance
export const KEY_COMPANY_ID = 'company_id'

// Barge Management
export const KEY_BARGE_MANAGEMENT_DETAIL_ID = 'barge_management_id'

// Tug Management
export const KEY_TUG_MANAGEMENT_DETAIL_ID = 'tug_management_id'

// MENU ICONS
export const KEY_MENU_ICONS = 'menu_icons'

// User
export const KEY_USER_ID = 'user_id'

// Tugboat BLU Availibility
export const BLU_GENERATED = 'BLU Generated'
export const BLU_NOT_GENERATED = 'BLU is not generated yet'

// FILE UPLOAD
export const MAX_FILE_UPLOAD_SIZE_BYTES = 5 * 1024 * 1024 // 5MB

// APP NAME
export const APP_NAME = 'BLMS'